import restService from './restService'

export default {
  getActive () {
    return restService.execute('get', '/v1/managers/all/web')
  },
  get (id) {
    return restService.execute('get', `/v1/managers/${id}`)
  },
  create (data, orgId) {
    return restService.execute('post', '/v1/managers', { user: data, organisation_id: orgId })
  },
  update (id, data, orgId) {
    return restService.execute('put', `/v1/managers/${id}`, { user: data, organisation_id: orgId })
  },
  delete (id) {
    return restService.execute('delete', `/v1/managers/${id}`)
  },
  sendInvitation (id) {
    return restService.execute('put', `/v1/managers/${id}/invitation`)
  },
}
